import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ErrorsService {
    forbiddenError$: BehaviorSubject<any> = new BehaviorSubject(null);
    caslForbiddenError$: BehaviorSubject<any> = new BehaviorSubject(null);
}
